/** Whose data a request field came from, which decides who can fix it. */
export const RequestFieldRole = {
  SHOPPER: "shopper",
  MERCHANT: "merchant",
} as const;
export type RequestFieldRole =
  (typeof RequestFieldRole)[keyof typeof RequestFieldRole];

/** A field of a label request party, named as the merchant banner names it. */
export const RequestField = {
  NAME: "name",
  COMPANY: "company",
  ADDRESS_LINE_1: "address_line_1",
  ADDRESS_LINE_2: "address_line_2",
  HOUSE_NUMBER: "house_number",
  CITY: "city",
  STATE: "state",
  POSTAL_CODE: "postal_code",
  PHONE: "phone",
  EMAIL: "email",
} as const;
export type RequestField = (typeof RequestField)[keyof typeof RequestField];

export const RequestFieldIssue = {
  MISSING: "missing",
  TOO_LONG: "too_long",
  INVALID: "invalid",
  MISMATCH: "mismatch",
} as const;
export type RequestFieldIssue =
  (typeof RequestFieldIssue)[keyof typeof RequestFieldIssue];

export const RequestFieldRoleValues = Object.values(RequestFieldRole);
export const RequestFieldValues = Object.values(RequestField);
export const RequestFieldIssueValues = Object.values(RequestFieldIssue);
